// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light Signup Page Styles - Matching Login Page Design */

.signupContainer {
  height: 100vh;
  width: 100%;
}

.link {
  text-decoration: none;
  color: #2e5263;
}

.logo-section img {
  width: auto;
  height: 50px;
  margin-bottom: 30px;
  cursor: pointer;
}

.imageContainer {
  width: 100%;
  height: 100%;
  background-image: url(https://images.unsplash.com/photo-1590473713374-dc331cb3f60e?q=80&w=1829&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D);
  background-repeat: no-repeat;
  background-color: #ebebeb;
  background-size: cover;
  background-position: center;
}

.formContainer {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center;
  padding-left: 25px;
  padding-right: 25px;
}

.title {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/lightSignup/LightSignup.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6LAA6L;EAC7L,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Light Signup Page Styles - Matching Login Page Design */\n\n.signupContainer {\n  height: 100vh;\n  width: 100%;\n}\n\n.link {\n  text-decoration: none;\n  color: #2e5263;\n}\n\n.logo-section img {\n  width: auto;\n  height: 50px;\n  margin-bottom: 30px;\n  cursor: pointer;\n}\n\n.imageContainer {\n  width: 100%;\n  height: 100%;\n  background-image: url(https://images.unsplash.com/photo-1590473713374-dc331cb3f60e?q=80&w=1829&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D);\n  background-repeat: no-repeat;\n  background-color: #ebebeb;\n  background-size: cover;\n  background-position: center;\n}\n\n.formContainer {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center;\n  padding-left: 25px;\n  padding-right: 25px;\n}\n\n.title {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
